import './repo/firebase';

import Vue from 'vue';

import App from './App.vue';
import router from './router';
import store from './store';
import validator from './validator';
import vuetify from './vuetify';

Vue.config.productionTip = false;

if (process.env.NODE_ENV !== 'production') {
  // tslint:disabled-next-line: no-var-requires
  const mock = require('./mock').default;
  mock();
}

Vue.use(validator);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
